"use client";

import { useEffect } from 'react';
import { initDatadogRUM } from '@/utils/datadog';

/**
 * Client component to initialize Datadog RUM
 * This must be a client component because Datadog RUM only works in the browser
 */
export default function DatadogProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Initialize Datadog RUM on client side only
    initDatadogRUM();
  }, []);

  return <>{children}</>;
}

